import isEqual from "lodash.isequal";

import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "@src/store/rootState";
import { getOfferProducts } from "@src/store/slices/offerProducts";

export const getUnsavedOfferProducts = createSelector(
  getOfferProducts,
  (state: RootState) => state.offerProducts.storedOfferProducts,
  (offerProducts, storedOfferProducts) => {
    return !isEqual(offerProducts, storedOfferProducts)
      ? offerProducts
      : undefined;
  }
);
